/** @module Classes */ /** typedoc */
class ReleaseLiveStatus {
    constructor(notLiveYet, live) {
        this.notLiveYet = notLiveYet;
        this.live = live;
    }
}

export { ReleaseLiveStatus };
